// extracted by mini-css-extract-plugin
export var fadeInAnimation = "StepsCalculator-module--fadeInAnimation--9b9d3";
export var hiddenDesktop = "StepsCalculator-module--hiddenDesktop--6751b";
export var hiddenMobile = "StepsCalculator-module--hiddenMobile--8575e";